import {
  AppWindow,
  Award,
  BarChart,
  BatteryLow,
  Brain,
  BrainCircuit,
  Briefcase,
  Calendar,
  ClipboardList,
  Clock,
  Clock3,
  Compass,
  EyeOff,
  Focus,
  Gauge,
  Globe,
  GripVertical,
  Heart,
  HeartCrack,
  Home,
  Layers,
  Lightbulb,
  Lock,
  MapPin,
  MessageCircle,
  Mic,
  Palette,
  PanelLeft,
  Rocket,
  Search,
  Settings,
  Shield,
  ShieldCheck,
  Sparkles,
  Square,
  Star,
  Target,
  TrendingUp,
  Trophy,
  Users,
} from "lucide-react";
import React from "react";

import { FacebookIcon } from "~/components/icons/facebook-icon";
import { InstagramIcon } from "~/components/icons/instagram-icon";
import { LinkedInIcon } from "~/components/icons/linkedin-icon";
import { YouTubeIcon } from "~/components/icons/youtube-icon";
import { ICON_NAMES, type TIconName } from "~/lib/icon-names";

import { IconD } from "./icon-d";

export const iconMap: Record<
  TIconName,
  {
    component: React.ComponentType<React.SVGProps<SVGSVGElement>>;
    label: string;
  }
> = {
  "app-window": { component: AppWindow, label: "App Window" },
  award: { component: Award, label: "Award" },
  barChart: { component: BarChart, label: "Bar Chart" },
  "battery-low": { component: BatteryLow, label: "Battery Low" },
  brain: { component: Brain, label: "Brain" },
  "brain-circuit": { component: BrainCircuit, label: "Brain Circuit" },
  briefcase: { component: Briefcase, label: "Briefcase" },
  calendar: { component: Calendar, label: "Calendar" },
  "clipboard-list": { component: ClipboardList, label: "Clipboard List" },
  clock: { component: Clock, label: "Clock" },
  "clock-3": { component: Clock3, label: "Clock 3" },
  compass: { component: Compass, label: "Compass" },
  dcm: { component: IconD, label: "Dream Coach Match" },
  "eye-off": { component: EyeOff, label: "Eye Off" },
  facebook: { component: FacebookIcon, label: "Facebook" },
  focus: { component: Focus, label: "Focus" },
  gauge: { component: Gauge, label: "Gauge" },
  globe: { component: Globe, label: "Globe" },
  "grip-vertical": { component: GripVertical, label: "Grip Vertical" },
  heart: { component: Heart, label: "Heart" },
  "heart-crack": { component: HeartCrack, label: "Heart Cracked" },
  home: { component: Home, label: "Home" },
  instagram: { component: InstagramIcon, label: "Instagram" },
  layers: { component: Layers, label: "Layers" },
  lightbulb: { component: Lightbulb, label: "Lightbulb" },
  linkedin: { component: LinkedInIcon, label: "LinkedIn" },
  location: { component: MapPin, label: "Location" },
  lock: { component: Lock, label: "Lock" },
  message: { component: MessageCircle, label: "Message" },
  mic: { component: Mic, label: "Mic" },
  palette: { component: Palette, label: "Palette" },
  "panel-left": { component: PanelLeft, label: "Panel Left" },
  rocket: { component: Rocket, label: "Rocket" },
  search: { component: Search, label: "Search" },
  settings: { component: Settings, label: "Settings" },
  shield: { component: Shield, label: "Shield" },
  "shield-check": { component: ShieldCheck, label: "Shield Check" },
  sparkles: { component: Sparkles, label: "Sparkles" },
  square: { component: Square, label: "Square" },
  star: { component: Star, label: "Star" },
  target: { component: Target, label: "Target" },
  "trending-up": { component: TrendingUp, label: "Trending Up" },
  trophy: { component: Trophy, label: "Trophy" },
  users: { component: Users, label: "Users" },
  youtube: { component: YouTubeIcon, label: "YouTube" },
} as const;

/** Renders an icon from the shared icon list by its name. */
export const NamedIcon = (props: { name: string; className?: string }) => {
  if (ICON_NAMES.includes(props.name as TIconName)) {
    const IconComponent = iconMap[props.name as TIconName].component;
    return <IconComponent className={props.className} />;
  }
  return null;
};
